import(/* webpackMode: "eager", webpackExports: ["AppWrapper"] */ "/home/runner/_work/nbit-branch-back-office/nbit-branch-back-office/src/app/AppWrapper.tsx");
